import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { useDispatch, useSelector } from "react-redux";
import { styled, useTheme } from "@mui/material/styles";
import { useMediaQuery, Paper } from "@mui/material";
import { setModal } from "../../Modules/Common/App";
import Draggable from 'react-draggable';
import Grow from "@mui/material/Grow";

const DraggablePaper = React.forwardRef(function DraggablePaper(props, ref) {
    const nodeRef = React.useRef(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // Disable draggable on mobile to prevent interference with touch events
    if (isMobile) {
        return <Paper ref={ref} {...props} />;
    }

    return (
        <Draggable
            nodeRef={nodeRef}
            handle=".MuiCardHeader-root"
        >
            <Paper ref={nodeRef} {...props} />
        </Draggable>
    );
});

const Transition = React.forwardRef(function Transition(props, ref) {
    const { children, ...rest } = props;
    return (
        <Grow direction="up" ref={ref} {...rest}>
            {children}
        </Grow>
    );
});

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiCardHeader-root': {
        cursor: 'move',
        [theme.breakpoints.down('md')]: {
            cursor: 'default', // Normal cursor on mobile
        },
    },
}));

export const Modal = () => {
    const app = useSelector((store) => store.app);
    const dispatch = useDispatch();
    const open = app.modal.open && !!app.modal.component;
    const component = app.modal.component;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const disableBackdropClose = app.modal.disableBackdropClose || false;

    const handleClose = (event, reason) => {
        if (disableBackdropClose && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
            return;
        }
        dispatch(setModal({ component: null, open: false }));
    };

    return (
        <StyledDialog
            fullWidth
            maxWidth={app.modal.size ?? 'sm'}
            fullScreen={fullScreen || app.modal.fullScreen}
            open={open}
            onClose={handleClose}
            PaperComponent={DraggablePaper}
            aria-labelledby="draggable-dialog-title"
            TransitionComponent={Transition}
        >
            {React.isValidElement(component) ? component : null}
        </StyledDialog>
    );
}
